import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Tooltip, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import { WorksheetModel } from '../../models';
import { CheckIconOutlined } from '../../../custom_shared/icons';
import './WorksheetProcessingResultsRenderer.less';

interface Props {
    worksheet: WorksheetModel;
}

const WorksheetProcessingResultsRenderer: React.FC<Props> = ({ worksheet }) => {
    if (!worksheet.isSuccessful) {
        return null;
    }

    return (
        <div className="worksheet-processing-results-renderer-container">
            <div className="results-content">
                <div className="results-left-column">
                    <CheckIconOutlined />
                </div>
                <div className="results-right-column">
                    <span>Worksheet submitted successfully.</span>

                    {worksheet.sicsWorksheetId && (
                        <div className="result-item-container">
                            <span className="item-label">Worksheet ID:</span>
                            <span>{worksheet.sicsWorksheetId}</span>
                            <Tooltip title="Copy">
                                <CopyOutlined
                                    className="copy-icon"
                                    onClick={() =>
                                        navigator.clipboard.writeText(worksheet.sicsWorksheetId ?? '').then(() => {
                                            message.success('Worksheet ID copied to clipboard', 1);
                                        })
                                    }
                                />
                            </Tooltip>
                        </div>
                    )}

                    {worksheet.sicsBusinessId && (
                        <div className="result-item-container">
                            <span className="item-label">Business ID:</span>
                            <span>{worksheet.sicsBusinessId}</span>
                            <Tooltip title="Copy">
                                <CopyOutlined
                                    className="copy-icon"
                                    onClick={() =>
                                        navigator.clipboard.writeText(worksheet.sicsBusinessId ?? '').then(() => {
                                            message.success('Business ID copied to clipboard', 1);
                                        })
                                    }
                                />
                            </Tooltip>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default observer(WorksheetProcessingResultsRenderer);
